import { DEFAULT_STATUS_ANNOUNCER_LABELS } from "./labels.js";
import { formatVolumeValue } from "../volume-indicator/status.js";
//#region src/core/ui/status-announcer/status.ts
/** Derives the immediate announcement for changed playback, captions, presentation, and playback-rate state. */
function deriveStatusAnnouncement(previous, snapshot, labels = DEFAULT_STATUS_ANNOUNCER_LABELS) {
	const announcements = [];
	if (hasChanged(previous.paused, snapshot.paused)) announcements.push(snapshot.paused ? labels.paused : labels.playing);
	if (hasChanged(previous.subtitlesShowing, snapshot.subtitlesShowing) && snapshot.subtitlesAvailable !== false) announcements.push(snapshot.subtitlesShowing ? labels.captionsOn : labels.captionsOff);
	if (hasChanged(previous.fullscreen, snapshot.fullscreen)) announcements.push(snapshot.fullscreen ? labels.fullscreen : labels.exitFullscreen);
	if (hasChanged(previous.pip, snapshot.pip)) announcements.push(snapshot.pip ? labels.pictureInPicture : labels.exitPictureInPicture);
	if (hasChanged(previous.playbackRate, snapshot.playbackRate)) announcements.push(labels.playbackRate(`${snapshot.playbackRate}×`));
	return announcements.length > 0 ? announcements.join(". ") : null;
}
/** Derives the announcement for changed volume or mute state. */
function deriveVolumeAnnouncement(previous, snapshot, labels = DEFAULT_STATUS_ANNOUNCER_LABELS) {
	if (!hasChanged(previous.volume, snapshot.volume) && !hasChanged(previous.muted, snapshot.muted)) return null;
	const volume = snapshot.volume ?? previous.volume;
	const muted = snapshot.muted ?? previous.muted;
	if (volume === void 0 && muted === void 0) return null;
	return muted || (volume ?? 0) <= 0 ? labels.muted : labels.volumeWithValue(formatVolumeValue(volume ?? 0));
}
function hasChanged(previous, next) {
	return previous !== void 0 && next !== void 0 && !Object.is(previous, next);
}
//#endregion
export { deriveStatusAnnouncement, deriveVolumeAnnouncement };

//# sourceMappingURL=status.js.map